module.exports = __webpack_public_path__ + "static/media/RitaSantos.5ee596a5.png";